/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// ./~/_lodash@4.17.4@lodash/_freeGlobal.js
// module id = 186
// module chunks = 1